/**
 * IDE application layout
 */
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/ide-app-layout-template.hbs';
import Radio from 'backbone.radio';

var globalCh = Radio.channel('global');
    var AppLayout = Marionette.View.extend({

        template: Handlebars.compile(template),

        regions : {
            top_nav       : "#top-nav",
            main_nav      : "#main-nav",
            secondary_nav : "#secondary-nav",
            profile_nav   : "#profile-nav",
            container     : "#container",
            alerts        : "#alerts",
            cookie        : "#cookie",
            dialogs       : "#dialogs",
            carousels     : "#carousels",
        },
        ui: {
            cookie_bar: '.cookie-bar',
            cookie_bar_ok: '#save-cookie-example'
        },
        events: {
            'click @ui.cookie_bar_ok': 'cookie_bar_clicked',
        },
        onRender: function(){
            var app_options = globalCh.request('app_options', 'features');
            if (localStorage.getItem("cookie-enable") != "1" && app_options.show_cookie_disclaimer) {
                this.ui.cookie_bar.show();
            } 
        },
        templateContext: function(){
            var app_options = globalCh.request('app_options', 'features');
            return {
                show_cookie_disclaimer: app_options.show_cookie_disclaimer
            };
        },
        cookie_bar_clicked: function(e){
            localStorage.setItem('cookie-enable', '1');
            this.ui.cookie_bar.hide();
        }
    });
    export default AppLayout;

